<template>
  <div class="newwarp boxsizing miniwarp">
    <!-- <el-progress class="progress" :text-inside="true" :show-text="false" :stroke-width="2" :percentage="progress"></el-progress> -->
    <div class="auto">
      <page-title title="实时" icon="fa-clock-o"></page-title>
    </div>
    <div class="m-t-15">
      <div class="summary auto" v-loading="summaryLoading">
        <el-row>
          <el-col :span="8" align="center">
            <div class="counts auto gray80">
              当前活跃用户
              <p><span class="blue">{{util.numberFormat(summaryTotal) || 0}}</span>位</p>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="summaryright auto">
              <p class="gray80">当前浏览量</p>
              <echarts :nohader="true" :data="summaryChart" height="200"></echarts>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" title="当前活跃用户访问来源 Top5 " tooltip="当前活跃用户扫描小程序码来源" v-loading="tableLoading1">
            <div slot="content">
              <el-row>
                <el-col :span="8">
                  <echarts :data="chartData1" title="" height="320" :nohader="true"></echarts>
                </el-col>
                <el-col :span="16">
                  <el-table :data="tableData1" style="width: 100%;margin-bottom: 20px;">
                    <el-table-column prop="name" label="来源">
                    </el-table-column>
                    <el-table-column prop="user" sortable label="人数" width="150">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.user)}}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" title="当前活跃用户访问方式 Top5 " tooltip="当前活跃用户是如何访问小程序的，按场景值分布" v-loading="tableLoading2">
            <div slot="content">
              <el-row>
                <el-col :span="8">
                  <echarts :data="chartData2" title="" height="320" :nohader="true"></echarts>
                </el-col>
                <el-col :span="16">
                  <el-table :data="tableData2" style="width: 100%;margin-bottom: 20px;">
                    <el-table-column prop="name" label="场景">
                    </el-table-column>
                    <el-table-column prop="total" sortable label="人数" width="150">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.total)}}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" title="当前活跃用户访问页面 Top5 " tooltip="当前活跃用户访问页面，按 Path 分布" v-loading="tableLoading3">
            <div slot="content">
              <el-row>
                <el-col :span="8">
                  <echarts :data="chartData3" title="" height="320" :nohader="true"></echarts>
                </el-col>
                <el-col :span="16">
                  <el-table :data="tableData3" style="width: 100%;margin-bottom: 20px;">
                    <el-table-column prop="name" label="页面">
                    </el-table-column>
                    <el-table-column prop="total" sortable label="人数" width="150">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.total)}}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { Data as DataModel } from '@/model'
import { Data as DataController } from '@/controller'
export default {
  data () {
    return {
      summaryLoading: false,
      summaryTotal: 0,
      summaryChart: '',
      pageSize: 5,
      tableLoading1: false,
      chartData1: '',
      tableData1: [],
      tableLoading2: false,
      chartData2: '',
      tableData2: [],
      tableLoading3: false,
      chartData3: '',
      tableData3: []
    }
  },
  methods: {
    async getRealtimeActive () {
      this.summaryLoading = true
      let res = await DataModel.Mini.getRealtimeActive()
      this.summaryLoading = false
      if (res['data'] && !res['err_code']) {
        this.summaryTotal = res['data']['total']
        this.summaryChart = DataController.Mini.realtimeOverviewLineSmooth(res['data']['list'] || '')
      }
    },
    async getRealtimeFromchannle () {
      this.tableLoading1 = true
      let res = await DataModel.Mini.getRealtimeFromchannle({
        size: this.pageSize
      })
      this.tableLoading1 = false
      if (res['data'] && !res['err_code']) {
        this.tableData1 = res['data']
        this.chartData1 = DataController.Mini.realtimePie1(res['data'])
      }
    },
    async getRealtimeActiveScene () {
      this.tableLoading2 = true
      let res = await DataModel.Mini.getRealtimeActiveScene({
        size: this.pageSize
      })
      this.tableLoading2 = false
      if (res['data'] && !res['err_code']) {
        this.tableData2 = res['data']
        this.chartData2 = DataController.Mini.realtimePie2(res['data'])
      }
    },
    async getRealtimeActiveRoute () {
      this.tableLoading3 = true
      let res = await DataModel.Mini.getRealtimeActiveRoute({
        size: this.pageSize
      })
      this.tableLoading3 = false
      if (res['data'] && !res['err_code']) {
        this.tableData3 = res['data']
        this.chartData3 = DataController.Mini.realtimePie3(res['data'])
      }
    }
  },
  created () {
    this.getRealtimeActive()
    this.getRealtimeFromchannle()
    this.getRealtimeActiveScene()
    this.getRealtimeActiveRoute()
  }
}
</script>

<style scoped>
.summary {
  background: #fff;
  margin: 15px 0 0;
  border-radius: 5px;
  font-size: 24px;
}
.counts {
  margin: 80px 0;
  line-height: 70px;
}
.counts p span {
  font-size: 34px;
  margin-right: 5px;
}
.summaryright {
  width: 100%;
}
.summaryright p {
  font-size: 16px;
  border-bottom: 1px solid #eee;
  margin: 20px;
  padding: 10px 0 20px;
}
.progress {
  position: fixed;
  width: calc(100% - 241px);
  top: 65px;
  left: 241px;
  z-index: 1;
}
</style>
